import { render, staticRenderFns } from "./PieChartCard.vue?vue&type=template&id=1c89e516&scoped=true"
import script from "./PieChartCard.vue?vue&type=script&lang=js"
export * from "./PieChartCard.vue?vue&type=script&lang=js"
import style0 from "./PieChartCard.vue?vue&type=style&index=0&id=1c89e516&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89e516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c89e516')) {
      api.createRecord('1c89e516', component.options)
    } else {
      api.reload('1c89e516', component.options)
    }
    module.hot.accept("./PieChartCard.vue?vue&type=template&id=1c89e516&scoped=true", function () {
      api.rerender('1c89e516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/PieChartCard.vue"
export default component.exports